import cn from 'classnames';

type Props = {
  overlay?: boolean;
};

export default function DRepProfileLoading({ overlay = false }: Props) {
  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center gap-4 bg-white px-4 text-center dark:bg-dark-neutral-950',
        overlay
          ? 'fixed inset-0 z-[1000] min-h-screen bg-white/95 backdrop-blur-sm dark:bg-dark-neutral-950/95'
          : 'min-h-calc-85'
      )}
      role="status"
      aria-live="polite"
      aria-label="Loading DRep profile"
    >
      <div
        className="h-14 w-14 animate-spin rounded-full border-2 border-primary-100 border-b-primary-900 dark:border-dark-neutral-700 dark:border-b-white"
        aria-hidden="true"
      />
      <div className="space-y-1">
        <p className="body18 font-semibold text-dark-neutral-950 dark:text-white">
          Loading DRep profile…
        </p>
        <p className="body14 text-neutral-600 dark:text-neutral-400">
          Fetching the latest on-chain details. This can take a moment.
        </p>
      </div>
    </div>
  );
}
